(ns io.repliance.answer-data
  "Helpers for extracting fields from answer data,
  to deal with inference search results represented as Answers.

  Collects code that is now duplicated in various places.

  Though eventually, it probably would be better to try represent inference results not as Answers directly,
  and in cases where we really want machine created answers,
  copy data from the search result into the relevant field at Answer creation time."
  (:require [clojure.string :as str]))

(defn document->response [answer]
  (or (-> answer :meta :classification :response_label) ;; Classifcation, if any available
      (:answer answer) ;; Otherwise the :answer field of Haystack Answer class
      (:response answer)) ;; Legacy data had the :answer text in :response field
  )

(defn document->comment [answer]
  (let [content (-> answer :meta :source_documents first :content)
        {:keys [start end]} (-> answer :offsets_in_document first)]
    (or (when (and (not (str/blank? content))
                   start
                   end)
          (subs content start end))
        (-> answer :meta :document_content)
        (:context answer))))

(defn get-response [source answer-data]
  (case source
    "human"
    (:response answer-data)

    nil
    (:response answer-data)

    "inferred_document"
    (document->response answer-data)

    "inferred_faq"
    ;; Prepare for renaming FAQ "answer" to "response"
    (or (-> answer-data :meta :faq :answer)
        (-> answer-data :meta :faq :response))
    nil))

(defn get-comment [source answer-data]
  (case source
    "human"
    (or (:additional-information answer-data)
        (:comment answer-data))

    nil
    (or (:additional-information answer-data)
        (:comment answer-data))

    "inferred_document"
    (document->comment answer-data)

    "inferred_faq"
    ;; Prepare for renaming FAQ "additional-information" to "comment"
    (or (-> answer-data :meta :faq :additional-information)
        (-> answer-data :meta :faq :comment))))
